module.exports = __webpack_public_path__ + "static/media/import_companies_example.4e6e6720.csv";